import React from 'react'
import GenericReport from '../GenericReport'

const TreatmentsBySupervisorPage: React.FC = () => {
  return <GenericReport reportId={2} />
}

export default TreatmentsBySupervisorPage
